var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotMem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2133 14.4933C12.08 14.48 11.92 14.48 11.7733 14.4933C8.59996 14.3866 6.07996 11.7866 6.07996 8.58663C6.07996 5.31996 8.71996 2.66663 12 2.66663C15.2666 2.66663 17.92 5.31996 17.92 8.58663C17.9066 11.7866 15.3866 14.3866 12.2133 14.4933Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 5.33337C24.4667 5.33337 26.5467 7.42671 26.5467 10C26.5467 12.52 24.5467 14.5734 22.0533 14.6667C21.9467 14.6534 21.8267 14.6534 21.7067 14.6667",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54671 19.4134C2.32004 21.5734 2.32004 25.0934 5.54671 27.24C9.21338 29.6934 15.2267 29.6934 18.8934 27.24C22.12 25.08 22.12 21.56 18.8934 19.4134C15.24 16.9734 9.22671 16.9734 5.54671 19.4134Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4534 26.6666C25.4134 26.4666 26.32 26.08 27.0667 25.5066C29.1467 23.9466 29.1467 21.3733 27.0667 19.8133C26.3334 19.2533 25.44 18.88 24.4934 18.6666",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotMem);
export default __webpack_public_path__ + "static/media/tot_mem.274dd3bc59ecf59824ac9f907e1582ab.svg";
export { ForwardRef as ReactComponent };